import { ReportEvaluationDto } from 'actions/evaluations/EvaluationsDtos';
import { ReportEvaluation, ReportEvaluationResult } from 'types/Evaluation';

export const convertToReportEvaluation = (
    reportEvaluationDto: ReportEvaluationDto
): ReportEvaluation => {
    return {
        id: reportEvaluationDto.id,
        expired: reportEvaluationDto.expired,
        boardingResult: reportEvaluationDto.final_result_boarding as ReportEvaluationResult,
        daycareResult: reportEvaluationDto.final_result_daycare as ReportEvaluationResult,
        groomingResult: reportEvaluationDto.final_result_grooming as ReportEvaluationResult
    };
};
